module.exports = __webpack_public_path__ + "static/media/fitness.307f4d41.jpg";